import apiClient from '@utils/apiClient.ts';
import { LoginRequest, LoginResponse } from './type.ts';

export const api = {
    login: async (credentials: LoginRequest): Promise<LoginResponse> => {
        const response = await apiClient.post<LoginResponse>(
            '/api/v1/login',
            credentials,
        );
        return response.data;
    },

    logout: async (): Promise<void> => {
        await apiClient.post('/logout');
    },

    refreshToken: async (): Promise<LoginResponse> => {
        const response = await apiClient.post<LoginResponse>('/refresh-token');
        return response.data;
    },

    // 필요시 추가 auth 관련 API들
    checkAuthStatus: async (): Promise<{ isValid: boolean }> => {
        const response = await apiClient.get('/auth/status');
        return response.data;
    },
};
